import React from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';

const SwissHeadquarters = () => (
  <div className="pb-6 border-b border-slate-700">
    <h3 className="text-xl font-semibold text-white mb-4">
      Malerfixpreis.ch - Floria Maler Sanierung
    </h3>
    <div className="space-y-4">
      <div className="flex items-start gap-3">
        <MapPin className="w-5 h-5 text-blue-400 flex-shrink-0 mt-1" />
        <div>
          <div className="font-semibold text-blue-400 mb-1">Hauptsitz Schweiz</div>
          <div className="text-slate-300">
            Fahrstrasse 7<br />
            5314 Kleindöttingen<br />
            Schweiz
          </div>
        </div>
      </div>

      <div className="flex items-start gap-3">
        <Phone className="w-5 h-5 text-blue-400 flex-shrink-0 mt-1" />
        <div>
          <div className="font-semibold text-white mb-1">Telefon</div>
          <a href="tel:0784417112" className="text-blue-400 hover:text-blue-300 transition-colors">
            0784417112
          </a>
        </div>
      </div>

      <div className="flex items-start gap-3">
        <Mail className="w-5 h-5 text-blue-400 flex-shrink-0 mt-1" />
        <div>
          <div className="font-semibold text-white mb-1">E-Mail</div>
          <a href="mailto:floria@malerfixpreis.ch" className="text-blue-400 hover:text-blue-300 transition-colors">
            floria@malerfixpreis.ch
          </a>
        </div>
      </div>

      <div className="flex items-start gap-3">
        <div className="w-5 h-5 text-blue-400 flex-shrink-0 mt-1 flex items-center justify-center font-bold text-sm">
          UID
        </div>
        <div>
          <div className="font-semibold text-white mb-1">UID</div>
          <div className="text-slate-300">CHE-379.835.443</div>
        </div>
      </div>
    </div>
  </div>
);

export default SwissHeadquarters;
